import { render, staticRenderFns } from "./checkin.vue?vue&type=template&id=70560069&"
import script from "./checkin.vue?vue&type=script&lang=js&"
export * from "./checkin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports